enum TransactionStatus {
  TX_NOT_ALLOWED = 'TX_NOT_ALLOWED',
  CANCELLED = 'CANCELLED'
}

export default TransactionStatus;
